import SnackBus from './SnackbarBus';

function message (text) {
    return { message: text };
}

export default {
    errors: {
        upload: function (msg) {
            return message('Upload error: ' + msg);
        },
        fetch: function (msg) {
            return message('Error: ' + msg);
        }
    }
};
